import { ThunkType } from "../../../../../core/store/reducers";
import { setData } from "../quarterlySecurityDataSlice";
import getQuarterlySecurityDataApi from "../api/getQuarterlySecurityData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return undefined;
	}

	const user = store.data.auth.current.user;
	const { filter } = store.ux.reports.securityCommission.quarterlylSecurity;

	const pagedTrades = await dispatch(getQuarterlySecurityDataApi(user, filter));

	dispatch(setData(pagedTrades || []));
};
